export default {
    yes: "SÌ",
    no: "NO"
}